/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountConfigInput } from '../models/AccountConfigInput';

export class ConnectCustomerVaultAccountRequest {
  /**
  * Account display name in Eon.
  */
  'name'?: string;
  'vaultAccountAttributes': AccountConfigInput;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultAccountAttributes",
      "baseName": "vaultAccountAttributes",
      "type": "AccountConfigInput",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectCustomerVaultAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

